/**
 * Company ids to send for an employer filter. A bureau employer may only see
 * their own companies, so a selection is narrowed to those and an empty (or
 * fully foreign) selection falls back to all of them. Everyone else gets
 * exactly what they picked, `undefined` included, so the request is unchanged.
 */
export function resolveFilterCompanyIds(
  selectedIds: string[],
  isBureauEmployer: boolean,
  ownCompanyIds: string[] | null | undefined,
): string[];
export function resolveFilterCompanyIds(
  selectedIds: string[] | undefined,
  isBureauEmployer: boolean,
  ownCompanyIds: string[] | null | undefined,
): string[] | undefined;
export function resolveFilterCompanyIds(
  selectedIds: string[] | undefined,
  isBureauEmployer: boolean,
  ownCompanyIds: string[] | null | undefined,
): string[] | undefined {
  if (!isBureauEmployer) return selectedIds;
  const ownIds = ownCompanyIds || [];
  const selected = (selectedIds || []).filter((id) => ownIds.includes(id));
  return selected.length > 0 ? selected : ownIds;
}
